import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import AuthGuard from './auth/AuthGuard';
import { authRoles } from './auth/authRoles';
import Loadable from './components/Loadable';
import MatxLayout from './components/MatxLayout/MatxLayout';
import EmpRoutes from './views/Employee/EmployeeRoutes';


//Masters
import DepartmentRoutes from './views/Department/DepartmentRoutes';
import MaterialCategoryRoutes from './views/MaterialCategory/MaterialCategoryRoutes';
import MaterialRoutes from './views/Material/MaterialRoutes';
import ProjectRoutes from './views/Project/ProjectRoutes';
import ProjectEmployeeRoutes from './views/ProjectEmployee/ProjectEmployeeRoutes';
import ProjectPlanRoutes from './views/ProjectPlan/ProjectPlanRoutes';
import ProjectPlanDayRoutes from './views/ProjectPlanDay/ProjectPlanRoutes';
import ProjectHolidayRoutes from './views/ProjectHoliday/ProjectHolidayRoutes';
import SubcontractorRoutes from './views/Subcontractor/SubcontractorRoutes';
import DesignationRoutes from './views/Designation/DesignationRoutes';




import QARoutes from './views/QA/QARoutes';
import PartnerRoutes from './views/Partner/PartnerRoutes';
import RewardRoutes from './views/Reward/RewardRoutes';
import ReferralRoutes from './views/Referral/ReferralRoutes';
import DocumentCategoryRoutes from './views/Documentcategory/DocumentCategoryRoutes';

import CompanyRoutes from './views/Company/CompanyRoutes';
import UserRoutes from './views/User/UserRoutes';
import RewardAllocationRoutes from './views/RewardAllocation/RewardAllocationRoutes';


import FileRoutes from './views/FileUpload/FileUploadRoutes';
import ReportRoutes from './views/Reports/ReportRoutes';

const NotFound = Loadable(lazy(() => import('app/views/sessions/NotFound')));
const JwtLogin = Loadable(lazy(() => import('app/views/sessions/JwtLogin')));
const JwtRegister = Loadable(
	lazy(() => import('app/views/sessions/JwtRegister'))
);
const ForgotPassword = Loadable(
	lazy(() => import('app/views/sessions/ForgotPassword'))
);
// dashboard page
const Analytics = Loadable(lazy(() => import('app/views/dashboard/Analytics')));

const routes = [
	{
		element: (
			<AuthGuard>
				<MatxLayout />
			</AuthGuard>
		),
		children: [
			{
				path: '/dashboard/default',
				element: <Analytics />,
				auth: authRoles.admin,
			},
			...DepartmentRoutes,
			...MaterialCategoryRoutes,
			...MaterialRoutes,
			...ProjectRoutes,
			...ProjectEmployeeRoutes,
			...ProjectPlanRoutes,
			...ProjectPlanDayRoutes,
			...ProjectHolidayRoutes,
			...SubcontractorRoutes,
			
			...QARoutes,	
			...PartnerRoutes,
			...RewardRoutes,
			...RewardAllocationRoutes,
			...ReferralRoutes,		
			...EmpRoutes,			
			...DocumentCategoryRoutes,

			...DesignationRoutes,
			...CompanyRoutes,			
			...UserRoutes,			
			...FileRoutes,
			...ReportRoutes
		],
	},

	// session pages route
	{ path: '/session/404', element: <NotFound /> },
	{ path: '/session/signin', element: <JwtLogin /> },
	{ path: '/session/signup', element: <JwtRegister /> },
	{ path: '/session/forgot-password', element: <ForgotPassword /> },

	{ path: '/', element: <Navigate to='/session/signin' /> },
	{ path: '*', element: <NotFound /> },
];

export default routes;
